<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 mt-2 py-0">
					<div class="d-flex align-items-center">
						<div class="d-flex align-items-center">
							<h5 style="font-size: 12px;" class="m-0 p-0 text-white bg-primary d-inline shadow-sm border border-primary rounded px-2 py-1">
							{{ dicts.page_title[dicts.lang] }}
							</h5>

						
					</div>
					</div>
					<button 
						class="float-right btn btn-primary shadow" 
						v-on:click="formInvoiceItemActive=!formInvoiceItemActive"
							v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'">
						{{ dicts.button_add_invoice[dicts.lang] }}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formInvoiceItemActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.tittle_form[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.so[dicts.lang] }}</label>
								<smart-search init url="/api/pemesanan/seeker/order"
								              v-on:update="(data)=>smartSearchOrderNumber(data)" key-tag="all"
								              :label-tag="['order_number']" :addon="{used:'no'}"
								              v-on:clear="(res)=>{clearData()}" :search-value="newsodatalabel"
								              @update-direct="(label)=>newsodatalabel=label"></smart-search>
							</div>
							
							<!-- NOMER INVOICE -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								
								<div class="d-flex align-items-center justify-content-between mb-1">
									<label class="mb-0">
									{{ dicts.no_invoice[dicts.lang] }}
									</label>

									<select
									class="form-select form-select-sm w-auto"
									v-model="invoiceType"
									>
									<option value="normal">Goverment</option>
									<option value="sw">Non Goverment</option>
									</select>
								</div>

							<div class="input-group">
								<!-- Enter the sequence number -->
								<input
								type="text"
								class="form-control w-25 rounded"
								v-model="invoiceId"
								@input="updateInvoiceNumber"
								maxlength="3"
								style="background-color: #ffffff;"
								/>

								<!--Invoice format -->
								<input
								type="text"
								class="form-control w-75 rounded"
								:value="formattedInvoiceNumber"
								readonly
								style="background-color: #f0f0f0;"
								/>
							</div>
							</div>

							<!-- TGL INVOICE STRAT-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
								<b-form-datepicker 
									today-button 
									reset-button 
									close-button 
									locale="id"
									:date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
									id="datepicker-invoice-date" 
									v-model="newInvoiceItem.invoice_date"
									class="mb-2">
								</b-form-datepicker>
							</div>
							<!-- TGL INVOICE AKHIR-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
								<b-form-datepicker 
									today-button 
									reset-button 
									close-button 
									locale="id"
									:date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
									id="datepicker-due-date" 
									v-model="newInvoiceItem.due_date" 
									class="mb-2"
								>
									{{ newInvoiceItem.due_date }}
								</b-form-datepicker>
							</div>

							<!--PEFORMA-->
							<div class="col-12 col-md-6 col-lg-4 mt-2" v-if="false">
								<label class="d-block">Proforma</label>
								<smart-select name="proforma" :options="proformaTypeOptions"
								              v-on:update="updateNewIiProforma"></smart-select>
							</div>

							<!--QR CODE-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">QR Code</label>
								<smart-select name="qr_code" :options="proformaQrCodeOptions"
								              v-on:update="updateNewQrCode"></smart-select>
							</div>

							<!--HARGA BARANG-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.hardware_price[dicts.lang] }}</label>
								<smart-search
									init
									url="/api/master/seeker/hardware-price"
									key-tag="id"
									v-on:update="(data) => smartSearchHardwarePrice(data)"
									:search-value="newhardwarepricelabel"
									:label-tag="['name_hardware_price','price']"
									@update-direct="(label) => newhardwarepricelabel = label"
									@input="calculateAmount"
								>
							    </smart-search>

								<!-- Displays price if available  -->
								<div v-if="selectedHardwarePrice > 0" class="mt-2">
									<strong>Price:</strong> Rp {{ selectedHardwarePrice.toLocaleString() }}
								</div>
							</div>

							<!-- UNIT ID  -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">CODE UNIT</label>
								
								<select class="form-control" v-model="newInvoiceItem.code_unit_id">
									<option value="" disabled>Pilih Code Unit</option>
									<option v-for="unit in codeUnits" :key="unit.id" :value="unit.id">
										{{ unit.unit }} - {{ unit.description }}
									</option>
								</select>


							</div>

							<!--DISCONT-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
								<smart-search 
									init 
									url="/api/master/seeker/discount" 
									key-tag="discount"
									@clear="smartSearchDiscount(null)"
									v-on:update="(data) => { 
										smartSearchDiscount(data);
										updateDiscountValue(data);
									}"
									:search-value="newdiscountlabel"
									@update-direct="(label) => newdiscountlabel = label">
								</smart-search>
							</div>

							<!--PPN-VAT-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.ppn[dicts.lang] }}</label>
								<smart-select name="ppn" 
									:options="ppnTypeOptions" 
									:value="newInvoiceItem.ppn" 
									v-on:update="updateNewPpn">
								</smart-select>
							</div>

							<!--PIC-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PIC</label>
								<input type="text" class="form-control w-100 rounded" v-model="newInvoiceItem.cp"/>
							</div>

							<!--JABATAN-->
							<div class="col-12 col-md-6 col-lg-4 mt-2 mb-2">
								<label class="d-block">{{ dicts.position[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceItem.department"/>
							</div>

							<!--REKENING BANGK-->
		                    <div class="col-12 col-md-6 col-lg-4 mt-2">
		                      <label class="d-block">REKENING BANK</label>
			                    <smart-search 
			                    :search-value="newInvoiceItem.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="newInvoiceItem.label_bank" key-tag="nama" :label-tag="['no_rekening','nama']" v-on:update="(data)=>{newInvoiceItem.id_bank=data.id}"  @update-direct="(label)=>newInvoiceItem.label_bank=label"></smart-search>
		                    </div>
							<div class="col-12 mt-2 rounded" style="border:1px solid #dee2e6 !important;">
								<h4 class="font-weight-bold">Detail invoice</h4>
								<hr>
								<div class="row" v-if="selectedMetaToCreate.length>0">
									<div class="col-4 my-1">
										<h5 class="mt-0 mb-3 bg-success text-light rounded pl-2 py-1">
											{{ dicts.choice_vessel[dicts.lang] }}</h5>
									</div>
								</div>
								<div class="row mt-1" v-if="selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.vessel[dicts.lang] }} </b></small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;"><small><b>ID
												transmitter: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_sn[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_jb[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.price[dicts.lang] }} (IDR)</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-for="(data,index) in selectedMetaToCreate" v-bind:key="'newSO'+data"
								     @click="dismissFromInvoice(index)">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.vessel.name }} </small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.hardware_setup.id_transmitter }}</small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>
													{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.serial_number : "-"
													}}<br>
													{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.purchase_order_metadata.hardware.hardware_name : "-"
													}}<br>
												</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>
													{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.serial_number : "-"
													}}<br>
													{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.purchase_order_metadata.hardware.hardware_name : "-"
													}}<br>
												</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														newInvoiceItem.price_hardware ? newInvoiceItem.price_hardware : 0 | numeral(
															"0,0")
													}}</small>
											</div>
											<div class="col-12 col-md-4  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='no'&&newAirtimePrice.name_airtime_price!=undefined">
												{{ newAirtimePrice.name_airtime_price }}
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='no'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='no'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='no'&&newAirtimePrice.name_airtime_price!=undefined">
												-
											</div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;"
											     v-if="newInvoiceItem.airtime=='no'&&newAirtimePrice.price!=undefined">
												<small>{{
														newAirtimePrice.price ? newAirtimePrice.price : 0 | numeral(
															"0,0")
													}}</small>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.discount_capital[dicts.lang] }}</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ newInvoiceItem.discount > 0 ? "-" : "" }}{{
														newInvoiceItem.discount | numeral("0,0")
													}}</b></small></div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>SUBTOTAL</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ newInvoiceItem.subtotal | numeral("0,0") }}</b></small>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.ppn[dicts.lang] }}</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												 <small><b>
												{{ newInvoiceItem.ppn ? (newInvoiceItem.subtotal * (newInvoiceItem.ppn / 100)) : 0 | numeral("0,0") }}
												</b></small>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-1" v-if=" selectedMetaToCreate.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class="col-12 col-md-10  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>TOTAL</b></small></div>
											<div class="col-12 col-md-2  py-2 px-2 text-right"
											     style="border:1px solid #dee2e6 !important;"><small><b>{{
													this.newInvoiceItem.total | numeral("0,0")
												}}</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-if="selectedMetaToCreate.length<1">
									<div class="col-5 my-1">
										<h5 class="mt-0 mb-3 bg-danger text-light rounded pl-2 py-1">
											{{ dicts.selected_vessel[dicts.lang] }}</h5>
									</div>
								</div>
							</div>
							<div class="col-12 mt-2 rounded" style="border:1px solid #dee2e6 !important;"
							     v-if="dataToCreate.metadata!=undefined">
								<h4 class="font-weight-bold">{{ dicts.item[dicts.lang] }}</h4>
								<hr>
								<div class="row mt-1" v-if=" dataToCreate.metadata.length>0">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.vessel[dicts.lang] }} </b></small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;"><small><b>ID
												transmitter: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_sn[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.no_jb[dicts.lang] }}: </b></small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small><b>{{ dicts.price[dicts.lang] }} (IDR)</b></small></div>
										</div>
									</div>
								</div>
								<div class="row" v-for="(data,index) in dataToCreate.metadata"
								     v-bind:key="'newReadySO'+data" @click="addToInvoice(index)">
									<div class="col-12">
										<div class="row px-2">
											<div class=" py-2 px-3 col-12 col-md-4"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.vessel.name }} </small></div>
											<div class=" py-2 px-3 col-12 col-md-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{ data.hardware_setup.id_transmitter }}</small></div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														data.hardware_setup.serial_number != null ? data.hardware_setup.serial_number.serial_number : "-"
													}}</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;">
												<small>{{
														data.hardware_setup.jb != null ? data.hardware_setup.jb.serial_number : "-"
													}}</small>
											</div>
											<div class="col-12 col-md-2  py-2 px-2"
											     style="border:1px solid #dee2e6 !important;"><small>Rp -</small></div>


										</div>
									</div>
								</div>

								<div class="row" v-if="dataToCreate.metadata.length<1">
									<div class="col-12 my-1">
										<h5 class="mt-0 mb-3">{{ dicts.nothing[dicts.lang] }}</h5>
									</div>
								</div>
							</div>


							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newInvoiceItemSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Invoice Perangkat Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewInvoiceItem">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Invoice Perangkat Baru.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewInvoiceItem">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewInvoiceItem">{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>
	
				<div class="col-12  my-2 py-0">
					
					<div class="search-container">
						<input 
							type="text"
							class="search-input"
							placeholder="search no invoice / vessel / client"
							v-model="searchTerm"
							@input="doSearch"
						/>
					</div>
					<!-- TAB BUTTON -->
					<ul class="nav nav-tabs mb-2">
						<li class="nav-item">
							<button
								class="nav-link"
								:class="[selectedTab==0 ? 'active' : '']" 
								href="#"
								@click="govermentTabe">
								GOVERNMENT
							</button>
						</li>

						<li class="nav-item">
							<button
								class="nav-link"
								:class="[selectedTab==2?'active':'']" 
								href="#"
							    v-on:click="selectedTab=2">
								NON GOVERNMENT
							</button>
						</li>
					</ul>
					<div class="col-12  my-2 py-0" v-if="selectedTab==0">
					<datatable ref="myTable"
							   :currentIdx="currentPage" 
							   :lang="dicts.lang" 
							   :datas="invoiceitems"
					           :structure="invoiceitemTableStructure" 
							   :init="loadData"
					           :next-url="nextUrl" 
							   :prev-url="prevUrl" 
							   :show-search="false"
							   :hide-pagination="true"
					        	use-filter
								use-seeker
								seeker-url="/api/pemesanan/seeker/invoice"
								use-xml xml-url="xmlUrl"
								@change-page="(isNext)=>{ changePage(isNext); }"
								@select-export="selectExportType"
								@refetch="(row)=>{rowLimit=row;getInvoiceItems()}"
								>
							   
						<template #customcell={obj,index} class="w-100">
							<td>{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td>{{ obj.client != null ? obj.client.customer_id : "-" }}</td>
							<td>
								{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.nbk
										? obj.invoice_metadata[0].order_metadata.hardware_setup.nbk
										: "-"
									}}
							</td>
							<td style="width:200px;">{{ obj.invoice_no }}</td>
							<td>
								 <!-- Safe check for nested data name customer -->
									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.client
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.client.legal_name
										: "-"
									}}
							</td>
							<!-- Safe check for nested data namae vassel-->
							<td>

									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.name
										: "-"
									}}
							</td>
							
							<td>    
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0
									? (obj.invoice_metadata[0].custom_display_transmitter || "-")
									: "-"
								}}  
							</td>
							<td>    
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0
									? (obj.invoice_metadata[0].custom_display_serial_number || "-")
									: "-"
								}}  
							</td>
							<td>    
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0
									? (obj.invoice_metadata[0].custom_display_jb || "-")
									: "-"
								}}
							</td>
							<td>
									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.gt
										: "-"
									}}
							</td>
							<td>	
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0 &&
									obj.invoice_metadata[0].order_metadata &&
									obj.invoice_metadata[0].order_metadata.hardware_setup
									? (
										obj.invoice_metadata[0].order_metadata.hardware_setup.forward ||
										"-"
										)
									: "-"
								}}	
							</td>
							<td>	
									{{ 
										obj.client != null ? obj.client.npwp : "-" 
									}}
							</td>
							<td>

									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.type_vessel
										: "-"
									}}
							</td>
							<td>
								{{ obj.invoice_date | timeformat }}
							</td>
							<td>
								{{ obj.due_date | timeformat }}
							</td>
							<!-- <td>
								<b-button v-if="obj.invoice_metadata[0].order_metadata.hardware_setup!=undefined
									&& obj.invoice_metadata[0].order_metadata.hardware_setup.date_active!=undefined
									&& obj.invoice_metadata[0].order_metadata.hardware_setup.date_active !=null
									&& obj.invoice_metadata[0].order_metadata.hardware_setup.serial_number!=null
									&& obj.invoice_metadata[0].order_metadata.hardware_setup.serial_number.device!=null"
								          v-b-modal.modal-sap class="btn btn-success"
								          :href="'https://api-billing.megahsurya.com/api/invoice/sap/'+obj.invoice_metadata[0].order_metadata.hardware_setup.id">
									<b>SAP</b></b-button>
							</td> -->
							<td>
								<!-- Dropdown Pilihan -->
								<b-dropdown text="Actions" variant="primary" class="mb-2">
									<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?qr=yes'" title="Invoice">
									<b-icon icon="printer"></b-icon> Invoice
								</b-dropdown-item>
								<!-- <b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?proforma=yes&qr=yes'" title="Proforma invoice">
									<b-icon icon="printer"></b-icon> PI
								</b-dropdown-item> -->
								<b-dropdown-item v-b-modal.modal-detail-histories @click="getHistories(obj.id)" title="History">
									<b-icon icon="clock-history"></b-icon> History
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-detail-invoice @click="selectedDetail=index">
									<b-icon icon="eye"></b-icon> View
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-edit-invoice @click="selectedIdforEdit=index" 
									v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
									<b-icon icon="pencil-square"></b-icon> Edit
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-delete @click="deleteId=obj.id;itemToDelete=obj" 
									v-if="['master_admin','admin','finance'].includes(role)" title="Delete">		
									<b-icon icon="trash"></b-icon> Delete
								</b-dropdown-item>
								</b-dropdown>
							</td>
						</template>
					</datatable>
					<!-- Pagination info + Prev Next -->
					<div class="d-flex justify-content-between align-items-center mt-2">

						<!-- Showing info -->
						<div class="text-muted">
							Showing {{ (currentPage - 1) * perPage + 1 }}
							to {{ ((currentPage - 1) * perPage) + invoiceitems.length }}
							of {{ totalItems }} entries
						</div>

						<!-- Prev Next Buttons -->
						<div>
							<b-button 
								class="mr-2"
								variant="outline-primary"
								:disabled="!prevUrl"
								@click="changePage(false)"
							>
								Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								:disabled="!nextUrl"
								@click="changePage(true)"
							>
								Next
							</b-button>
						</div>

					</div>
					</div>
					
				</div>
				<!-- Tabel List INV NON GOVERMENT -->
				<div class="col-12 w-100 my-3" v-if="selectedTab==2">
					<datatable ref="myTable"
							   :currentIdx="currentPage" 
							   :lang="dicts.lang" 
							   :datas="invoiceitemsNonGov"
					           :structure="invoiceitemTableNonGoverment" 
							   :init="loadData"
					           :next-url="nextUrl" 
							   :prev-url="prevUrl" 
							   :show-search="false"
							   :hide-pagination="true"
							   :key="datatableKey"
					        	use-filter
								use-seeker
								seeker-url="/api/pemesanan/seeker/invoice-non-goverment"
								use-xml xml-url="xmlUrl"
								@change-page="(isNext)=>{ changePage(isNext); }"
								@select-export="selectExportType"
								@refetch="(row)=>{rowLimit=row;getInvoiceINonGoverment()}"
								>
							   
							
						<template #customcell={obj,index} class="w-100">
							<td>{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td>{{ obj.client != null ? obj.client.customer_id : "-" }}</td>
							
							<td style="width:200px;">{{ obj.invoice_no }}</td>
							<td>
								 <!-- Safe check for nested data name customer -->
									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.client
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.client.legal_name
										: "-"
									}}
							</td>
							<!-- Safe check for nested data namae vassel-->
							<td>

									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.name
										: "-"
									}}
							</td>
							<td>	
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0 &&
									obj.invoice_metadata[0].order_metadata &&
									obj.invoice_metadata[0].order_metadata.hardware_setup
									? (
										obj.invoice_metadata[0].order_metadata.hardware_setup.display_id_transmitter ||
										"-"
										)
									: "-"
								}}	
							</td>
							<td>	
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0 &&
									obj.invoice_metadata[0].order_metadata &&
									obj.invoice_metadata[0].order_metadata.hardware_setup
									? (
										obj.invoice_metadata[0].order_metadata.hardware_setup.display_serial_number ||
										"-"
										)
									: "-"
								}}	
							</td>
							<td>	
								
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0 &&
									obj.invoice_metadata[0].order_metadata &&
									obj.invoice_metadata[0].order_metadata.hardware_setup
									? (
										obj.invoice_metadata[0].order_metadata.hardware_setup.display_jb ||
										"-"
										)
									: "-"
								}}
							</td>
							
							<td>	
								{{
									obj.invoice_metadata &&
									obj.invoice_metadata.length > 0 &&
									obj.invoice_metadata[0].order_metadata &&
									obj.invoice_metadata[0].order_metadata.hardware_setup
									? (
										obj.invoice_metadata[0].order_metadata.hardware_setup.forward ||
										"-"
										)
									: "-"
								}}	
							</td>
							<td>	
									{{ 
										obj.client != null ? obj.client.npwp : "-" 
									}}
							</td>
							<td>

									{{
										obj.invoice_metadata &&
										obj.invoice_metadata.length > 0 &&
										obj.invoice_metadata[0].order_metadata &&
										obj.invoice_metadata[0].order_metadata.hardware_setup &&
										obj.invoice_metadata[0].order_metadata.hardware_setup.vessel
										? obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.type_vessel
										: "-"
									}}
							</td>
							<td>
								{{ obj.invoice_date | timeformat }}
							</td>
							<td>
								{{ obj.due_date | timeformat }}
							</td>
							
							<td>
								<!-- Dropdown Options -->
								<b-dropdown text="Actions" variant="primary" class="mb-2">
									<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?qr=yes'" title="Invoice">
									<b-icon icon="printer"></b-icon> Invoice
								</b-dropdown-item>
								<!-- <b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/item/'+obj.id+'?proforma=yes&qr=yes'" title="Proforma invoice">
									<b-icon icon="printer"></b-icon> PI
								</b-dropdown-item> -->
								<b-dropdown-item v-b-modal.modal-detail-histories @click="getHistories(obj.id)" title="History">
									<b-icon icon="clock-history"></b-icon> History
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-detail-invoice @click="selectedDetail=index">
									<b-icon icon="eye"></b-icon> View
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-edit-invoice @click="selectedIdforEdit=index" 
									v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
									<b-icon icon="pencil-square"></b-icon> Edit
								</b-dropdown-item>
								<b-dropdown-item v-b-modal.modal-delete @click="deleteId=obj.id;itemToDelete=obj" 
									v-if="['master_admin','admin','finance'].includes(role)" title="Delete">		
									<b-icon icon="trash"></b-icon> Delete
								</b-dropdown-item>
								</b-dropdown>
							</td>
						</template>
					</datatable>
					<!-- Pagination info + Prev Next -->
					<div class="d-flex justify-content-between align-items-center mt-2">

						<!-- Showing info -->
						<div class="text-muted">
							Showing {{ (currentPage - 1) * perPage + 1 }}
							to {{ ((currentPage - 1) * perPage) + invoiceitemsNonGov.length }}
							of {{ totalItems }} entries
						</div>

						<!-- Prev Next Buttons -->
						<div>
							<b-button 
								class="mr-2"
								variant="outline-primary"
								:disabled="!prevUrl"
								@click="changePage(false)"
							>
								Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								:disabled="!nextUrl"
								@click="changePage(true)"
							>
								Next
							</b-button>
						</div>

					</div>
				</div>
				<!-- EDIT FROM -->
				<b-modal id="modal-edit-invoice" 
						 title="EDIT" 
						 scrollable 
						 no-close-on-backdrop size="lg"
				         @hide="editModalClose" 
						 v-if="!loadData&&currentInvoiceItems.length>0">
					
					<div class="row" v-if="currentInvoiceItems[selectedIdforEdit]!=undefined">
						
						<!-- Sales Order -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.so[dicts.lang] }}</label>
							<div class="form-control w-100 rounded">
								{{
									currentInvoiceItems[selectedIdforEdit].sales_order != undefined && 
									currentInvoiceItems[selectedIdforEdit].sales_order != null ? 
									currentInvoiceItems[selectedIdforEdit].sales_order.order_number : "-"
								}}
							</div>
						</div>

						<!-- Invoice Number -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.no_invoice[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="currentInvoiceItems[selectedIdforEdit].invoice_no"/>
							
						</div>

						<!-- Invoice Date -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-invoice-date"
							                   v-model="currentInvoiceItems[selectedIdforEdit].invoice_date" class="mb-2">
								{{ currentInvoiceItems[selectedIdforEdit].invoice_date }}
							</b-form-datepicker>
						</div>

						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-due-date"
							                   v-model="currentInvoiceItems[selectedIdforEdit].due_date" class="mb-2">
								{{ currentInvoiceItems[selectedIdforEdit].due_date }}
							</b-form-datepicker>
						</div>

						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.start_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-update-start-date-activation"
							                   @input="(e)=>{currentInvoiceItems[selectedIdforEdit].active_date_setup=e}"
							                   :value="currentInvoiceItems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active"
							                   class="mb-2"></b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button locale="id"
							                   :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
							                   id="datepicker-update-end-date-activation"
							                   @input="(e)=>{currentInvoiceItems[selectedIdforEdit].due_date_setup=e}"
							                   v-model="currentInvoiceItems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due"
							                   class="mb-2">{{ currentInvoiceItems[selectedIdforEdit].due_date_setup }}
							</b-form-datepicker>
						</div>
						
						<!--PRICE-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PRICE OF GOODS</label>
								
								<smart-search
									init
									url="/api/master/seeker/hardware-price"
									key-tag="id"
									:search-value="invoiceitems[selectedIdforEdit].price_label"
									:label-tag="['name_hardware_price','price']"
									v-on:update="smartSearchUpdateHardwarePrice"
									@update-direct="(label) => {
										invoiceitems[selectedIdforEdit].price_label = label
									}"
								>
								</smart-search>
							</div>
							<!--DISKON-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
								<smart-search init url="/api/master/seeker/discount" usedefault
											:default-value="currentInvoiceItems[selectedIdforEdit].discount_detail!=undefined&&invoiceitems[selectedIdforEdit].discount_detail.discount"
											key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
											v-on:update="(data)=>smartSearchUpdateDiscount(data)">
								</smart-search>
							</div>
							<!--TOTAL-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">TOTAL {{ dicts.discount[dicts.lang] }}</label>
								<div class="form-control w-100 rounded">
									{{ currentInvoiceItems[selectedIdforEdit].discount | numeral("0,0") }}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">SUB TOTAL</label>
								<div class="form-control w-100 rounded">
									{{ currentInvoiceItems[selectedIdforEdit].subtotal | numeral("0,0") }}
								</div>
							</div>

							<!--PPN-VAT-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.ppn[dicts.lang] }} {{ currentInvoiceItems[selectedIdforEdit].ppn_number }}</label>
								
								<smart-select
									name="ppn"
									:options="ppnTypeOptions"
									usedefault
									:default-value="currentInvoiceItems[selectedIdforEdit].ppn"
									v-on:update="(value) => {
										currentInvoiceItems[selectedIdforEdit].ppn = value;
										currentInvoiceItems[selectedIdforEdit].ppn_number = value;
										$forceUpdate();
										calculateUpdateAmount();
									}"
								></smart-select>

							</div>

							<!--TOTAL-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">TOTAL</label>
								<div class="form-control w-100 rounded">
									{{ currentInvoiceItems[selectedIdforEdit].total | numeral("0,0") }}
								</div>
							</div>

						
						<!--PIC-->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PIC</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="currentInvoiceItems[selectedIdforEdit].cp"/>
						</div>

						<!--JABATAN-->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.position[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="currentInvoiceItems[selectedIdforEdit].department"/>
						</div>

						<!--REKENING BANK-->
	                    <div class="col-12 col-md-6 col-lg-4 mt-2">
	                      <label class="d-block">REKENING BANK</label>
	                      <smart-search 
							
							init url="/api/master/seeker/bank" 
							usedefault 
							:default-value="currentInvoiceItems[selectedIdforEdit].bank == null ? '' : currentInvoiceItems[selectedIdforEdit].bank.nama" 
							:search-value="newInvoiceItem.label_bank" 
							key-tag="nama" 
							v-on:update="(data)=>{currentInvoiceItems[selectedIdforEdit].id_bank=data.id}"  
							@update-direct="(label)=>newInvoiceItem.label_bank=label">

						  </smart-search>
	                    </div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Successfully Update Device Invoice Data.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Failed to update Device Invoice.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" 
									v-on:click="updateInvoiceItem">
									{{ dicts.submit[dicts.lang] }}
								</button>
								<b-button class="btn btn-secondary mr-2" 
									@click="$bvModal.hide('modal-edit-invoice')">
									{{ dicts.close[dicts.lang] }}
								</b-button>
							</div>
						</div>
					</template>
			</b-modal>

			<!-- DETAIL HISTORY INV -->
				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories" size="lg"
				         title="Detail history" scrollable no-close-on-backdrop>
					<datatable no-toolbar 
								responsive 
								:datas="histories" 
								:structure="historyTableStructure"
					           	:init="loadHistoriesData" 
								use-seeker seeker-url="/api/report/json/invoice-item-history"
					           @searching="(val)=>!val.status?getHistories():histories=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nama Admin:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.editor != null ? obj.editor.name : "-"
											}}</b>
										</div>
										<hr class="my-1">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal Perubahan:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).created_at | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nomor Invoice:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).invoice_no }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal Invoice:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).invoice_date | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tanggal invoice jatuh tempo:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												JSON.parse(obj.old_data).due_date | timeformat
											}}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Jabatan:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).cp }}</b>
										</div>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">PIC:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ JSON.parse(obj.old_data).department }}</b>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.editor != null ? obj.editor.name : "-" }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).created_at | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_no }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_date | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).due_date | timeformat }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).cp }}</td>
							<td v-if="!isMobile">{{ JSON.parse(obj.old_data).department }}</td>
						</template>
					</datatable>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-histories'):''">Close
							</b-button>
						</div>
					</template>
				</b-modal>

				<!--DETAIL INVOICE-->
				<b-modal no-close-on-esc content-class="m-0" size="lg" title="" id="modal-detail-invoice"
				         scrollable no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&invoiceitems.length>0">
						<b-row class="pt-1" v-if="invoiceitems[selectedDetail]!=undefined">
							<b-col cols="12">
								<table v-if="invoiceitems.length>0" rules="rows" class="table w-100"
								       style="overflow-x:auto;">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">DETAIL INVOICE
										</th>
									</tr>
									<tr>
										<th class="text-left" scope="row">{{ dicts.so[dicts.lang] }}</th>
										<td class="text-left">
											{{
												invoiceitems[selectedDetail].sales_order != undefined && 
												invoiceitems[selectedDetail].sales_order != null ? 
												invoiceitems[selectedDetail].sales_order.order_number : "-"

											}}
										</td>
									</tr>
									<tr>
										<th class="text-left" scope="row">KODE UNIT</th>
										<td class="text-left">
											{{
												invoiceitems[selectedDetail].code_unit_id
												? codeUnits.find(unit => unit.id === invoiceitems[selectedDetail].code_unit_id).unit || "-"
												: "-"
											}}
										</td>
									</tr>
									
							
									<!--NUBER BUKU KAPAL (NBK)-->
									<tr>
										<th class="" scope="row">NBK</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].invoice_metadata[0] != undefined && 
												invoiceitems[selectedDetail].invoice_metadata[0] != null ? 
												invoiceitems[selectedDetail].invoice_metadata[0].order_metadata.hardware_setup.nbk : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">PIC</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].cp ? invoiceitems[selectedDetail].cp : "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.position[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].department ? invoiceitems[selectedDetail].department : "-"
											}}
										</td>
									</tr>
									
									<tr>
										<th class="" scope="row">{{ dicts.hardware_price[dicts.lang] }} (IDR)</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].price_hardware ? 
												invoiceitems[selectedDetail].price_hardware : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									
									<tr>
										<th class="" scope="row">{{ dicts.airtime_price[dicts.lang] }} (IDR)</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].price_hardware ? invoiceitems[selectedDetail].price_airtime : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Subtotal</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].subtotal ? invoiceitems[selectedDetail].subtotal : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.ppn[dicts.lang] }}</th>
										<td class="">
											{{
												invoiceitems[selectedDetail].ppn_number ? invoiceitems[selectedDetail].ppn_number : "-"
											}}
										</td>
										
									</tr>
									<tr>
										<th class="" scope="row">{{ dicts.discount[dicts.lang] }}</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].discount ? invoiceitems[selectedDetail].discount : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">TOTAL</th>
										<td class="">Rp {{
												invoiceitems[selectedDetail].total ? invoiceitems[selectedDetail].total : "-" | numeral(
													"0,0")
											}}
										</td>
									</tr>
									
									
									</tbody>
								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteUserState)?$bvModal.hide('modal-detail-invoice'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

			</div>
		</div>
		<modal-delete url="/api/pemesanan/invoice/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			{{ dicts.desc_delete[dicts.lang] }}:<br>
			<ul>
				<li>{{ dicts.no_invoice[dicts.lang] }}: {{ itemToDelete.invoice_no }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	
	data() {
		return {
			base_ppn: 0,
			currentPage: 1,
			perPage: 10,
			totalItems: 0,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			selectedHistories: 0,
			role: "",
			isNewAirtime: false,
			dataEdit: null,//step 1 edit
			selectedDetail: 0,
			selectedIdforEdit: 0,
			newsodatalabel: "",
			isMobile: false,
			currentdiscountlabel: "",
			newairtimepricelabel: "",
			newhardwarepricelabel: "",
			selectedHardwarePrice: 0,
			newdiscountlabel: "",
			newBanklabel: "",
			itemToDelete: {},

			invoiceitems: [],
			invoiceitemsNonGov: [],
			invoiceSequence: '',

			datatableKey: 0,
			invoiceitmNonGoverment: [],
			searchKeyword: '', 
			filteredInvoices: [],
			allInvoices: [],
			searchQuery: '',
			searchTerm: '',
			histories: [],
			searchValue: "",
			loadData: true,
			loadHistoriesData: true,
			savingNewInvoiceItem: false,
			errorNewInvoiceItem: false,
			errorInvoiceItemList: [],
			existingClientResult: [],
			newInvoiceItemSaved: false,
			selectedTab: 0, // 0 = Goverment, 2 = Non Goverment
			newHardwarePrice: 0,
			updateHardwarePrice: 0,
			updateAirtimePrice: 0,
			newAirtimePrice: {},
			newDiscount: {},
			updateDiscount: {},
			updateSaved: false,
			errorUpdate: false,
			updating: false,
			deleteId: 0,
			invoiceId: "000", //Default value for invoiceId
			invoiceType: 'normal',
			dataToCreate: [],
			selectedMetaToCreate: [],
			codeUnits: [],
			selectedCodeUnit: '',
			activeTab: 'government',
			cache: {
				editItem: {}
			},
			newInvoiceItem: {
				invoice_no: "",
				invoice_date: new Date().toISOString().substr(0, 10),
				client_id: "",
				totalPPN: 0,
				new_order_metadata_id: [],
				due_date:  new Date().toISOString().substr(0, 10),
				npwp: "",
				proforma: "no",
				airtime: "no",
				order_number_id: "",
				hardware_name_id: "",
				vessel_id: "",
				telephone: "",
				email: "",
				serial_number_id: "",
				idtransmitter_id: "",
				jb_invoice: "",
				price_hardware: "",
				price_airtime: "",
				discount: 0,
				discount_id: "",
				id_bank: "",
				label_bank: "",
				price_hardware_id: "",
				subtotal: 0,
				ppn: 0,
				ppn_number: 0,
				total: 0,
				status: "Actual",
				cp: "",
				code_unit_id:"",
				department: "",
				
			},
			formInvoiceItemActive: false,
			historyTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "NAMA ADMIN",
						en: "ADMIN NAME"
					},
					key: null
				},
				{
					label: {
						id: "TGL PERUBAHAN",
						en: "UPDATED AT"
					},
					key: null
				},
				{
					label: {
						id: "NOMER INVOICE",
						en: "INVOICE NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "INVOICE DATE",
						en: "INVOICE DATE"
					},
					key: null
				},
				{
					label: {
						id: "TGL DUE DATE",
						en: "TGL DUE DATE"
					},
					key: null
				},
				{
					label: {
						id: "POSITION",
						en: "POSITION"
					},
					key: null
				},
				{
					label: {
						id: "PIC",
						en: "PIC"
					},
					key: null
				}
			],
			invoiceitemTableStructure: [
				//label: nama heading, key: nama object property
				{label: "NO", key: null},
				{
					label: {
						id: "CID",
						en: "CID"
					},
					key: null
				},
				{
					label: {
						id: "NBK",
						en: "NBK"
					},
					key: null
				},
				{
					label: {
						id: "NO INVOICE",
						en: "NO INVOICE"
					},
					key: null
				},
				{
					label: {
						id: "OWNER",
						en: "OWNER"
					},
					key: null
				},
				{
					label: {
						id: "SHIP NAME",
						en: "NAME VASSEL"
					},
					key: null
				},
				{
					label: {
						id: "SPKP ID",
						en: "SPKP ID"
					},
					key: null
				},
				{
					label: {
						id: "SERIAL NUMBER",
						en: "SERIAL NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "NO JB",
						en: "NO JB"
					},
					key: null
				},
				{
					label: {
						id: "GT",
						en: "GT"
					},
					key: null
				},
				{
					label: {
						id: "STATUS REPORT",
						en: "STATUS REPORT"
					},
					key: null
				},
				{
					label: {
						id: "NPWP",
						en: "NPWP"
					},
					key: null
				},
				{
					label: {
						id: "TYPE VASSEL",
						en: "TYPE VASSEL"
					},
					key: null
				},
				{
					label: {
						id: "INVOICE DATA",
						en: "INVOICE DATA"
					},
					key: null
				},
				{
					label: {
						id: "DUE DATE",
						en: "DUE DATE"
					},
					key: null
				},
				
				{
					label: {
						id: "ACTION",
						en: "ACTION"
					},
					key: null
				}
			],
			invoiceitemTableNonGoverment: [
				//label: nama heading, key: nama object property
				{label: "NO", key: null},
				{
					label: {
						id: "CID",
						en: "CID"
					},
					key: null
				},
				
				{
					label: {
						id: "NO INVOICE",
						en: "NO INVOICE"
					},
					key: null
				},
				{
					label: {
						id: "OWNER",
						en: "OWNER"
					},
					key: null
				},
				{
					label: {
						id: "SHIP NAME",
						en: "NAME VASSEL"
					},
					key: null
				},
				{
					label: {
						id: "NO IMO",
						en: "NO IMO"
					},
					key: null
				},
				{
					label: {
						id: "SERIAL NUMBER",
						en: "SERIAL NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "NO JB",
						en: "NO JB"
					},
					key: null
				},
				
				{
					label: {
						id: "STATUS REPORT",
						en: "STATUS REPORT"
					},
					key: null
				},
				{
					label: {
						id: "NPWP",
						en: "NPWP"
					},
					key: null
				},
				{
					label: {
						id: "TYPE VASSEL",
						en: "TYPE VASSEL"
					},
					key: null
				},
				{
					label: {
						id: "INVOICE DATA",
						en: "INVOICE DATA"
					},
					key: null
				},
				{
					label: {
						id: "DUE DATE",
						en: "DUE DATE"
					},
					key: null
				},
				{
					label: {
						id: "ACTION",
						en: "ACTION"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				page_title: {
					id: "INVOICE OF GOODS",
					en: "INVOICE OF GOODS"
				},
				button_add_invoice: {
					id: "TAMBAH",
					en: "ADD NEW"
				},
				tittle_form: {
					id: "FORM INVOICE",
					en: "FORM INVOICE"
				},
				so: {
					id: "NOMER SO",
					en: "SO NUMBER"
				},
				no_invoice: {
					id: "NOMER INVOICE",
					en: "INVOICE NUMBER"
				},
				invoice_date: {
					id: "DATE INVOICE",
					en: "DATE INVOICE"
				},
				invoice_due_date: {
					id: "DUE DATE",
					en: "DUE DATE"
				},
				hardware_price: {
					id: "PRICE OF GOODS",
					en: "PRICE OF GOODS"
				},
				airtime_price: {
					id: "HARGA AIRTIME",
					en: "AIRTIME PRICE"
				},
				discount: {
					id: "DISKON",
					en: "DISCOUNT"
				},
				position: {
					id: "JABATAN",
					en: "POSITION"
				},
				choice_vessel: {
					id: "Kapal terpilih untuk membuat invoice",
					en: "The vessel selected to create the invoice"
				},
				vessel: {
					id: "NAMA KAPAL",
					en: "VESEL NAME"
				},
				no_spkid: {
					id: "SPKP ID",
					en: "SPKP ID"
				},
				no_sn: {
					id: "SERIAL NUMBER",
					en: "SN number"
				},
				no_jb: {
					id: "NOMER JB",
					en: "JB NUMBER"
				},
				price: {
					id: "HARGA",
					en: "PRICE"
				},
				discount_capital: {
					id: "DISKON",
					en: "DISCOUNT"
				},
				selected_vessel: {
					id: "Pilih item tersedia untuk membuat invoice",
					en: "Select an available item to create an invoice"
				},
				item: {
					id: "Item tersedia",
					en: "Item available"
				},
				nothing: {
					id: "Tidak ada detail tersedia",
					en: "No details available"
				},
				submit: {
					id: "Simpan",
					en: "Submit"
				},
				close: {
					id: "Tutup",
					en: "Close"
				},
				client: {
					id: "CUSTOMER",
					en: "CUSTOMER"
				},
				npwp: {
					id: "NPWP",
					en: "NPWP"
				},
				desc_delete: {
					id: "Yakin mau menghapus data dengan detail berikut",
					en: "You are sure you want to delete data with the following details"
				},
				ppn: {
					id: "PPN-VAT",
					en: "VAT"
				},
				start_date: {
					id: "TGL AKTIVASI",
					en: "ACTIVATION DATE"
				},
				due_date: {
					id: "JATUH TEMPO",
					en: "Due date"
				}
			},
			proformaTypeOptions: [
				{label: "TIDAK", value: "no"},
				{label: "YA", value: "yes"}
			],
			proformaQrCodeOptions: [
				{label: "TIDAK", value: "no"},
				{label: "YA", value: "yes"}
			],
			statusTypeOptions: [
				{label: "Actual", value: "Actual"},
				{label: "Temporary", value: "Temporary"}
			],
			ppnTypeOptions: [
				{label: "TIDAK", value: 0},
				{ label: '11', value: 11 },
				{ label: '12', value: 12 },
				
			],
			airtimeTypeOptions: [
				{label: "TIDAK", value: "no"},
				{label: "YA", value: "yes"}
			],
			
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getInvoiceItems();
		this.getHistories();
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing invoice item lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		
		this.getSetPpn();
	},
	// Convert months to Roman numerals
	computed: {
		
		formattedInvoiceNumber() {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const monthIndex = currentDate.getMonth();

			const romanMonths = [
				"I","II","III","IV","V","VI",
				"VII","VIII","IX","X","XI","XII"
			];

			const romanMonth = romanMonths[monthIndex];

			// FORMAT DIFFERENCE
			const middle =
				this.invoiceType === 'sw'
				? 'INV-MSP-SW'
				: 'INV-MSP';

			return `${this.invoiceId}/${middle}/${romanMonth}/${year}`;
		},

		currentInvoiceItems() {
			return this.selectedTab === 2
			? this.invoiceitemsNonGov
			: this.invoiceitems;
		},

		//  Determine the active API
		currentInvoiceApi() {
			return this.selectedTab === 2
			? this.$baseUrl + "/api/pemesanan/invoice-non-goverment/"
			: this.$baseUrl + "/api/pemesanan/invoice/";
		}

	},
	
	methods: {
			
		

		changePage(isNext) {
			var url = isNext ? this.nextUrl : this.prevUrl;
			let params = new URL(url).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/invoice?limit=" + this.rowLimit + "&page=" + myParams;

			this.getInvoiceItems(newUrl);
		},

		editPreparation(index) {
			console.log("index for edit: " + index);
			this.selectedIdforEdit = index;
			console.log(this.invoiceitems[index]);
			this.cache.editItem = Object.assign({}, this.invoiceitems[index]);
			console.log(this.cache.editItem);
			console.log("edit journey start here");
		},
		
		translateProforma(proforma) {
			var label = "";
			switch (proforma) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		translateAirtime(airtime) {
			var label = "";
			switch (airtime) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		editModalClose(mdl) {
			console.log(this.cache.editItem);
			this.$set(this.invoiceitems, this.selectedIdforEdit, 
			Object.assign({}, this.cache.editItem));
			this.cache.editItem = Object.assign({}, {});
			console.log(this.invoiceitems[this.selectedIdforEdit]);
			this.$forceUpdate();
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				
			}
		},
		detailModalClose(mdl) {
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-invoice");
			}
		},
		dismissFromInvoice(index) {
			this.dataToCreate.metadata.push(this.selectedMetaToCreate[index]);
			this.newInvoiceItem.new_order_metadata_id.splice(index, 1);
			this.selectedMetaToCreate.splice(index, 1);
			this.$forceUpdate();
			this.calculateAmount();
		},
		addToInvoice(index) {
			console.log(index);
			console.log(this.dataToCreate);
			this.newInvoiceItem.new_order_metadata_id.push(this.dataToCreate.metadata[index].id);
			this.selectedMetaToCreate.push(this.dataToCreate.metadata[index]);
			this.dataToCreate.metadata.splice(index, 1);
			this.$forceUpdate();
			this.calculateAmount();
		},
		getInvoiceItemsPDF() {
			this.loadData = true;
			axios.get(this.$baseUrl + "https://api-billing.megahsurya.com/api/invoiceitem-pdf/item/" + id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.invoiceitems = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		getHistories(id) {
			var url = this.$baseUrl + "/api/report/json/invoice-item-history/" + id;
			this.loadHistoriesData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.histories = result.data;
				this.loadHistoriesData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadHistoriesData = false;
			});
		},
		handleSearch(val) {
			console.log("search result:", val);
			if (!val.status || !val.data || val.data.length === 0) {
				this.getInvoiceItems(); // Refresh to all data
			} else {
				this.invoiceitems = val.data; // Display filter results
			}
			
		},
		changeTab(tab) {
            if (this.activeTab === tab) return;

			this.activeTab = tab;
			this.getInvoiceItems();
        },
		doSearch() {
			this.getInvoiceItems(null, this.searchTerm);
			this.getInvoiceINonGoverment(null, this.searchTerm);
		},
		
		getInvoiceItems(url = null, search = '') {
			this.loadData = true;

			let finalUrl = url;
			if (!finalUrl) {
				finalUrl = this.$baseUrl + "/api/pemesanan/invoice?limit=" + this.rowLimit;
				if (search) {
				finalUrl += `&search=${encodeURIComponent(search)}`;
				}
			}

			axios.get(finalUrl, {
				headers: {
				Authorization: "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log("Invoice results:", result);

				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.totalItems = result.data.total;

				this.invoiceitems = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				if (err.response && err.response.status === 401) {
				localStorage.removeItem("accessToken");
				this.$router.push("/login");
				}
				console.error("Error loading data:", err);
				this.loadData = false;
			});
		},
		
		
		getInvoiceINonGoverment(url = null, search = '') {
			this.loadData = true;

			let finalUrl = url;
			if (!finalUrl) {
				finalUrl = this.$baseUrl + "/api/pemesanan/invoice-non-goverment?limit=" + this.rowLimit;

				if (search) {
					finalUrl += `&search=${encodeURIComponent(search)}`;
				}
			}

			axios.get(finalUrl, {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("accessToken")
				}
			})
			.then((result) => {
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.totalItems = result.data.total;

				// DATA IS CERTAINLY NON-GOVERNMENTAL
				this.invoiceitemsNonGov = result.data.data;

				this.loadData = false;
			})
			.catch((err) => {
				if (err.response && err.response.status === 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.error("Error loading data:", err);
				this.loadData = false;
			});
		},

		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getInvoiceItems();
			}
		},
		updateDiscountValue(data) {
			if (data && data.discount_value) {
				this.updateDiscount.price = data.discount_value;
				this.updateDiscount.discount_type = data.discount_type; 
				this.calculateUpdateAmount(); 
			} else {
				this.updateDiscount.price = 0; 
				this.updateDiscount.discount_type = null;
				this.calculateUpdateAmount();
			}
		},
		calculateAmount() {
			
			this.newInvoiceItem.subtotal = parseInt(this.newInvoiceItem.price_hardware) * this.selectedMetaToCreate.length;

			let airtimeTotal = 0;
			if (this.newInvoiceItem.airtime === "no" && this.newAirtimePrice.price !== undefined) {
				airtimeTotal = parseInt(this.newAirtimePrice.price) * this.selectedMetaToCreate.length;
			}

			this.newInvoiceItem.subtotal += airtimeTotal;

			if (this.newDiscount.discount_type === "percentage") {
				this.newInvoiceItem.discount = this.newInvoiceItem.subtotal * (this.newDiscount.price / 100);
			} else if (this.newDiscount.discount_type === "nominal") {
				this.newInvoiceItem.discount = this.newDiscount.price;
			}

			//-recover subtotals-//
			const discountedSubtotal = this.newInvoiceItem.subtotal - this.newInvoiceItem.discount;
			this.newInvoiceItem.subtotal = discountedSubtotal; 

			const ppnValue = discountedSubtotal * (this.newInvoiceItem.ppn / 100);
			this.newInvoiceItem.total = Math.round((discountedSubtotal + ppnValue) / 10) * 10;

			console.log("Subtotal:", this.newInvoiceItem.subtotal);
			console.log("Total:", this.newInvoiceItem.total);
			
		},
		
		calculateUpdateAmount() {
			
			const item = this.invoiceitems[this.selectedIdforEdit];

			const totalMetadata = item.invoice_metadata.length || 0;

			// === SUBTOTAL ===
			item.subtotal = item.price_hardware * totalMetadata;

			if (item.price_airtime) {
				item.subtotal += item.price_airtime * totalMetadata;
			}

			// === DISCOUNT ===
			if (this.updateDiscount.discount_type === "percentage") {
				item.discount = item.subtotal * (this.updateDiscount.price / 100);
			} else if (this.updateDiscount.discount_type === "nominal") {
				item.discount = this.updateDiscount.price;
			} else {
				item.discount = 0;
			}

			item.subtotal -= item.discount;

			// === PPN ===
			const ppnValue = item.ppn > 0
				? item.subtotal * (item.ppn / 100)
				: 0;

			// === TOTAL ===
			item.total = item.subtotal + ppnValue;
			
		},
		updateNewIiProforma(data) {
			this.newInvoiceItem.proforma = data;
		},
		updateNewQrCode(data) {
			this.newInvoiceItem.qr_code = data;
		},
		updateNewIiStatus(data) {
			this.newInvoiceItem.status = data;
		},
		updateNewPpn(data) {
			this.newInvoiceItem.ppn = data;
			this.newInvoiceItem.ppn_number = data;
			this.base_ppn = data;
			this.calculateAmount();
		},
		
		
		
		updateNewIiAirtime(newValue) {
			if (!newValue || newValue === "no") {
				this.isNewAirtime = false;
				this.newInvoiceItem.airtime = "no";
				return;
			}

			this.newInvoiceItem.airtime = newValue;

			if (newValue === "yes") {
				this.isNewAirtime = true;
				this.getDefaultAirtime();
			} else {
				this.isNewAirtime = false;
			}
		},

		getDefaultAirtime() {
			axios.get(this.$baseUrl + "/api/master/airtime-price-default", {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result.data);
				this.newAirtimePrice = result.data;
				this.$forceUpdate();
				this.calculateAmount();
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		resetPostData() {
			this.newInvoiceItem = {
				invoice_no: "",
				invoice_date: "",
				client_id: "",
				totalPPN: 0,
				new_order_metadata_id: [],
				due_date: "",
				npwp: "",
				proforma: "no",
				airtime: "no",
				order_number_id: "",
				hardware_name_id: "",
				vessel_id: "",
				client_id: "",
				telephone: "",
				email: "",
				serial_number_id: "",
				idtransmitter_id: "",
				jb_invoice: "",
				price_hardware: "",
				price_airtime: "",
				discount: 0,
				discount_id: "",
				id_bank: "",
				label_bank: "",
				price_hardware_id: "",
				subtotal: 0,
				ppn: "yes",
				ppn_number:0,
				total: 0,
				subtotal: 0,
				status: "Actual",
				cp: "",
				department: ""
			};
			this.dataToCreate = [],
				this.selectedMetaToCreate = [];
		},
		saveNewInvoiceItem() {

			console.log(this.newInvoiceItem);
			this.savingNewInvoiceItem = true;
			this.errorNewInvoiceItem = false;
			if (
				this.newInvoiceItem.code_unit_id != "" &&
				this.newInvoiceItem.invoice_no != "" &&
				this.newInvoiceItem.order_number_id != "" &&
				this.newInvoiceItem.invoice_date != "" &&
				this.newInvoiceItem.price_hardware != "" &&
				this.newInvoiceItem.subtotal > 0 &&
				this.newInvoiceItem.total > 0
			) {
				// console.log(this.newInvoiceItem);
				// return false;
				axios.post(
					this.$baseUrl + "/api/pemesanan/invoice",
					this.newInvoiceItem,
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.log(result);
					this.savingNewInvoiceItem = false;
					this.newInvoiceItemSaved = true;
					this.getInvoiceItems();
					this.resetPostData();
					setTimeout(() => {
						this.formInvoiceItemActive = false;
						this.newInvoiceItemSaved = false;
					}, 1000);
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.clear();
					console.log(err.response);
					this.savingNewInvoiceItem = false;
					this.errorNewInvoiceItem = true;
				});
			} else {
				console.log("data invalid");
				this.errorNewInvoiceItem = true;
			}
		},
		
		updateInvoiceItem() {
			this.updating = true;
			this.errorUpdate = false;

			const items = this.currentInvoiceItems;
			const apiUrl = this.currentInvoiceApi;
			const selectedItem = items[this.selectedIdforEdit];

			//  Safety check
			if (!selectedItem) {
			console.error("Invoice item tidak ditemukan");
			this.updating = false;
			return;
			}

			axios.put(
			apiUrl + selectedItem.id,
			selectedItem,
			{
				headers: {
				Authorization: "Bearer " + localStorage.getItem("accessToken")
				}
			}
			)
			.then((result) => {
			if (result.status === 200) {

				// cache
				this.cache.editItem = selectedItem;

				// update nested date
				if (selectedItem.active_date_setup !== undefined) {
				selectedItem.invoice_metadata[0]
					.order_metadata.hardware_setup.date_active =
					selectedItem.active_date_setup;
				}

				if (selectedItem.due_date_setup !== undefined) {
				selectedItem.invoice_metadata[0]
					.order_metadata.hardware_setup.date_due =
					selectedItem.active_date_setup;
				}

				this.updating = false;
				this.updateSaved = true;

				setTimeout(() => {
				this.updateSaved = false;
				this.$bvModal.hide("modal-edit-invoice");
				}, 1000);
			}
			})
			.catch((err) => {
			if (err.response && err.response.status === 400) {
				alert("Invoice number sudah digunakan.");
				this.updating = false;
				return;
			}

			if (err.response && err.response.status === 401) {
				localStorage.removeItem("accessToken");
				this.$router.push("/login");
			}

			this.updating = false;
			this.errorUpdate = true;

			setTimeout(() => {
				this.errorUpdate = false;
			}, 1000);

			console.error(err);
			});
		},
		
		newUsernameChange() {
			this.newInvoiceItem.password = this.newInvoiceItem.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newInvoiceItem.role = newValue;
		},
		setNewClientId(newId) {
			this.newInvoiceItem.clientId = newId;
			console.log(this.newInvoiceItem.clientId);
		},
		smartSearchOrderNumber(data) {
			this.selectedMetaToCreate = [];
			this.dataToCreate = data;

			this.newInvoiceItem.client_id = data.client_id;

			console.clear();
			console.log(data);

			this.newInvoiceItem.order_number_id = data.id;
		},
		smartSearchHardwarePrice(data) {
			if (!data) return;

			this.newInvoiceItem.price_hardware = data.price;
			this.newInvoiceItem.price_hardware_id = data.id;

			this.newHardwarePrice = data;
			this.$forceUpdate();

			this.calculateAmount();
			if (data && data.price) {
            	this.selectedHardwarePrice = data.price; 
        	}
		},
		smartSearchUpdateHardwarePrice(data) {

			// this.invoiceitems[this.selectedIdforEdit].price_hardware = data.price;
			// this.invoiceitems[this.selectedIdforEdit].price_hardware_id = data.id;
			
			// this.updateHardwarePrice = data;
			// this.$forceUpdate();
			// this.calculateUpdateAmount();
			const item = this.invoiceitems[this.selectedIdforEdit];

			item.price_hardware = Number(data.price);
			item.price_hardware_id = data.id;
			item.price_label = `${data.name_hardware_price} - ${data.price}`;

			this.updateHardwarePrice = data;

			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		
		smartSearchAirtimePrice(data) {
			this.newInvoiceItem.price_airtime = data.price;
			this.newInvoiceItem.airtime_price_id = data.id;
			this.newAirtimePrice = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateAirtimePrice(data) {
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].price_airtime = null;
				this.invoiceitems[this.selectedIdforEdit].airtime_price_id = null;
				this.updateAirtimePrice = {};
			} else {
				this.invoiceitems[this.selectedIdforEdit].price_airtime = data.price;
				this.invoiceitems[this.selectedIdforEdit].airtime_price_id = data.id;
				this.updateAirtimePrice = data;
			}
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchDiscount(data) {
			
			if (data == null) {
			// Reset diskon
			this.newInvoiceItem.discount = 0;
			this.newInvoiceItem.discount_id = "";
			this.newDiscount = {}; 

			this.calculateAmount();
			this.$forceUpdate();
			return;
		}

		// Discount handling logic (nominal or percentage)
		if (data.discount_type === "percentage") {
			this.newInvoiceItem.discount = this.newInvoiceItem.subtotal * (data.price / 100);
		} else if (data.discount_type === "nominal") {
			this.newInvoiceItem.discount = data.price;
		} else {
			this.newInvoiceItem.discount = 0;
		}

		this.newInvoiceItem.discount_id = data.id;
		this.newDiscount = data;

		this.calculateAmount();
		this.$forceUpdate();
		},
		smartSearchUpdateDiscount(data) {
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].discount = 0;
				this.invoiceitems[this.selectedIdforEdit].discount_id = "";
				this.updateDiscount = {};
				this.currentdiscountlabel = "";
				this.$forceUpdate();
				return;
			}
			if (data.discount_type == "nominal") {
				this.invoiceitems[this.selectedIdforEdit].discount = data.price;
			}
			this.invoiceitems[this.selectedIdforEdit].discount_id = data.id;
			this.updateDiscount = data;
			this.currentdiscountlabel = data.discount;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchBank(data)
		{
			if (data == null) {
				this.newInvoiceItem.id_bank = "";
				this.newBanklabel = "";
				this.$forceUpdate();
				return;
			}
			this.newInvoiceItem.id_bank = data.id;
			this.newBanklabel = data.nama;
			this.$forceUpdate();
		},
		smartSearchBankUpdate(data)
		{
			// console.log('name')
			if (data == null) {
				this.invoiceitems[this.selectedIdforEdit].id_bank = "";
				this.newBanklabel = "";
				this.$forceUpdate();
				return;
			}
			this.invoiceitems[this.selectedIdforEdit].id_bank = data.id;
			this.newBanklabel = data.nama;
			this.$forceUpdate();
		},

		handlePriceSelection(data) {
			if (data && data.price) {
			
			this.selectedHardwarePrice = data.price;
			} else {
			this.selectedHardwarePrice = 0;
			}
		},
		
		validateInvoiceId() {
			this.invoiceId = this.invoiceId.replace(/\D/g, '').slice(0, 6); 
    		this.updateInvoiceNumber();
		},
		updateInvoiceNumber() {
		
		this.newInvoiceItem.invoice_no = this.formattedInvoiceNumber;
		},
		
		fetchCodeUnits() {
			const url = this.$baseUrl + '/api/code-units';  // Replace with your base API URL

			axios.get(url, {
				headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
				}
		})
		.then((response) => {
			
			if (response.data.success) {
			this.codeUnits = response.data.data;
			} else {
			console.error('Data tidak ditemukan atau terjadi kesalahan.');
			}

			
			this.loadData = false;
		})
		.catch((err) => {
			
			if (err.response && err.response.status == 401) {
			localStorage.removeItem('accessToken'); 
			this.$router.push('/login');  
			}
			console.error('Terjadi kesalahan saat mengambil data:', err);
			this.loadData = false; 
		});
		},
		selectExportType(type) {
			this.$emit("select-export", type); 
		},
		govermentTabe() {
			this.selectedTab = 0;               
			this.getInvoiceItems();        
		},
		refreshTable() {
			this.datatableKey++;
			this.getInvoiceINonGoverment();
		}
		
	},
	mounted() {
		this.fetchCodeUnits();
		this.updateInvoiceNumber();
		this.updateNewIiAirtime(this.newInvoiceItem.airtime);
		this.getInvoiceItems();
		this.getInvoiceINonGoverment();
    	
	},
	watch: {
		selectedTab(val) {
			this.invoiceType = (val === 2) ? 'sw' : 'normal';
			this.selectedIdforEdit = null;
		},

		selectedIdforEdit: {
		immediate: true,
		handler() {
			const invoiceNo =
				this.currentInvoiceItems[this.selectedIdforEdit].invoice_no;

			if (!invoiceNo) return;

			// Take the last 3 digits (001)
			const match = invoiceNo.match(/(\d{3})(?!.*\d)/);

			this.invoiceSequence = match ? match[1] : '';
		}
	}
	}
}
</script>
<style>
#modal-detail-histories .modal-dialog {
	max-width: 90vw !important;
}
</style>
<style scoped>
.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 10.5rem);
}*/
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
table th, table td {
    text-align: center !important;
}
.search-container {
  position: relative; 
  width: 100%; 
  margin-top: 15px; 
  padding-left: 0;
  margin-left: 0%; 
}

.search-input {
  position: absolute;
  left: 80%; 
  top: 20px; 
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 20%; 
}

</style>
